import psl from 'psl';

import { Input } from '@/lib/base/forms/input/input';
import { getPropertyTypeIconComponent } from '@/lib/crm/utils/icons/PropertyTypeIcon';

import type { PropertyInputProps } from './TextInput';

function extractRootDomain(hostname: string): string {
  const parsed = psl.parse(hostname);
  if (parsed.error || !parsed.domain) {
    // Fallback to hostname if parsing fails
    return hostname;
  }
  return parsed.domain;
}

export const DomainInput: React.FC<PropertyInputProps> = ({
  propertyType,
  value,
  onChange,
  disabled = false,
  placeholder,
  size = 'sm',
}) => {
  const Icon = getPropertyTypeIconComponent(propertyType);

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const pastedText = event.clipboardData.getData('text').trim();

    try {
      const url = new URL(pastedText);
      const domain = extractRootDomain(url.hostname);

      event.preventDefault();
      onChange(domain);
    } catch {
      // Not a valid URL, let normal paste behavior occur
    }
  };

  return (
    <Input
      type='text'
      value={(value as string) || ''}
      onChange={onChange}
      onPaste={handlePaste}
      isDisabled={disabled}
      icon={Icon}
      placeholder={placeholder || 'example.com'}
      size={size}
      aria-label={propertyType.label}
    />
  );
};
